import _ from 'lodash'

export default {
  SET_ORGANIZATION_CONFIG(state, payload) {
    state.config = _.cloneDeep(payload)
  },
  UPDATE_ORGANIZATION_CONFIG_VALUE(state, { path, value }) {
    _.set(state.config, path, value)
  },
}
